import { PROJECT_TYPES } from '../constants';
import activ8Actions from './activ8/Activ8ActionsMapping';
import id8Actions from './id8/Id8ActionsMapping';
import resonanceActions from './resonance/resonanceActionsMapping';
import aiStudioActions from './ai-studio/AiStudioActionsMapping';
import storyActions from './story/StoryActionsMapping';
import genieActions from './genie/GenieActionsMapping';
import genieGoActions from './genie-go/GenieGoActionsMapping';
import scoutActions from './scout/ScoutActionsMapping';
import sonarActions from './sonar/SonarActionsMapping';

const actionMappings = {
  [PROJECT_TYPES.ID8]: id8Actions,
  [PROJECT_TYPES.RESONANCE]: resonanceActions,
  [PROJECT_TYPES.ACTIV8]: activ8Actions,
  [PROJECT_TYPES.GENIE]: genieActions,
  [PROJECT_TYPES.GENIE_GO]: genieGoActions,
  [PROJECT_TYPES.SCOUTV2]: scoutActions,
  [PROJECT_TYPES.SONAR]: sonarActions,
  AI_STUDIO: aiStudioActions,
  STORY: storyActions,
};

export default actionMappings;
